export const invoiceStatus = {
  statusPaymentLinkSent: 0,
  statusOutstanding: 1,
  statusPaymentInitiated: 2,
  statusPaid: 3,
  statusFailed: 4,
  statusInvalidAmountPaid: 5
}

export const invoiceItemTypeIds = {
  basicFeatures: 1,
  additionalFeatures: 2,
  setupFee: 3,
  discountAdditionalFeatures: 4,
  discountPromotionCode:5,
  creditCardPaymentFee: 6,
  sum:7,
  subTotal:8,
  tax:9,
  total:10,
  discountBasicFeatures:11,
  discountSetupFee:12,
}

export const BILLING_TYPE_IDS = {
  recurring: 1,
  nonrecurring: 2
}

export const INVOICE_ITEM_ADDITION = {
  percent: 1
}

export const featureList = {
  1: { id: 1, title: 'ITEM_FEATURE_DESC_1' },
  2: { id: 2, title: 'ITEM_FEATURE_DESC_2' },
  3: { id: 3, title: 'ITEM_FEATURE_DESC_3' },
  4: { id: 4, title: 'ITEM_FEATURE_DESC_4' },
  5: { id: 5, title: 'ITEM_FEATURE_DESC_5' },
  6: { id: 6, title: 'ITEM_FEATURE_DESC_6' },
  7: { id: 7, title: 'ITEM_FEATURE_DESC_7' },
  8: { id: 8, title: 'ITEM_FEATURE_DESC_8' },
  9: { id: 9, title: 'ITEM_FEATURE_DESC_9' },
  10: { id: 10, title: 'ITEM_FEATURE_DESC_10' },
  11: { id: 11, title: 'ITEM_FEATURE_DESC_11' },
  12: { id: 12, title: 'ITEM_FEATURE_DESC_12' },
  13: { id: 13, title: 'ITEM_FEATURE_DESC_13' },
  14: { id: 14, title: 'ITEM_FEATURE_DESC_14' },
  15: { id: 15, title: 'ITEM_FEATURE_DESC_15' },
  16: { id: 16, title: 'ITEM_FEATURE_DESC_16' },
  17: { id: 17, title: 'ITEM_FEATURE_DESC_17' },
  18: { id: 18, title: 'ITEM_FEATURE_DESC_18' },
  19: { id: 19, title: 'ITEM_FEATURE_DESC_19' },
  20: { id: 20, title: 'ITEM_FEATURE_DESC_20' },
}

export const itemInvoiceTypeAddInfos = {
  1: {
    addTitle: 'INVOICE_ITEM_TYPE_ID_1_ADD_TITLE',
    features: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
  },
  2: {
    addTitle: 'INVOICE_ITEM_TYPE_ID_2_ADD_TITLE',
    features: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    addFeatures: [17, 18, 19, 20]
  }
}
